import React from 'react';
import Logo from '../../components/logo/logo';
import css from './initial-layout.scss';
import auth from '../../store/auth.js'
import Button from '../../components/button/button';
import { useHistory } from "react-router-dom";

const InitialLayout = (props) => {
    const history = useHistory();
    return (
        <div className={css.root}>
            <Logo />
            <div className={css.under}>
                <div class={css.inner}>
                    <div>This service currently is under construction</div>
                    <a class="sign-form__link"
                        href="mailto:support@victoriasmedical.ai">support@victoriasmedical.ai</a>
                </div>
            </div>
            <Button style={css.logoutBtn} onClick={() => { history.push("/"); auth.logout(); }}
                caption={'На главную'}>
            </Button>

        </div>
    )
};

export default InitialLayout;